<div class="main-wrapper">
  <router-outlet></router-outlet>
</div>
